export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/dashboard": [9,[2]],
		"/dashboard/analytics": [10,[2]],
		"/dashboard/analytics/card-report": [11,[2]],
		"/dashboard/analytics/cost-report": [12,[2]],
		"/dashboard/analytics/dashboard": [13,[2]],
		"/dashboard/analytics/income-and-cost": [14,[2]],
		"/dashboard/analytics/income-report": [15,[2]],
		"/dashboard/analytics/provider-report": [16,[2]],
		"/dashboard/analytics/resident-debt": [17,[2]],
		"/dashboard/analytics/resident-report": [18,[2]],
		"/dashboard/communication/new-sms": [19,[2]],
		"/dashboard/communication/sms-history": [20,[2]],
		"/dashboard/communication/sms-templates": [21,[2]],
		"/dashboard/condo": [22,[2]],
		"/dashboard/condo/[id]/[propertyUnitId]": [23,[2,3]],
		"/dashboard/documents": [24,[2]],
		"/dashboard/faq": [25,[2]],
		"/dashboard/notifications": [26,[2]],
		"/dashboard/orders": [27,[2]],
		"/dashboard/prices": [28,[2]],
		"/dashboard/profile": [29,[2]],
		"/dashboard/transactions": [30,[2]],
		"/dashboard/transfer/auto": [31,[2]],
		"/dashboard/transfer/auto/create": [32,[2]],
		"/dashboard/transfer/auto/edit/[id]": [33,[2,4]],
		"/dashboard/transfer/edit/[id]": [34,[2,5]],
		"/dashboard/transfer/my-account": [35,[2]],
		"/dashboard/transfer/my-account/edit/[id]": [36,[2,6]],
		"/dashboard/transfer/other-account": [37,[2]],
		"/dashboard/transfer/other-account/edit/[id]": [38,[2,7]],
		"/forgot-password": [39],
		"/register": [40],
		"/shadcn-demo": [41],
		"/shadcn-demo/compare": [42],
		"/shadcn-demo/sizes": [43]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';